import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a8593fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-cell" }

import { computed, PropType } from 'vue';
import moment from "moment-timezone";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeCellTemplate',
  props: {
  cellData: { type: Object as PropType<any>, default: () => {} }
},
  setup(__props) {

const props = __props;

const celldisplay = computed(() => {
  const time = moment(props.cellData.text, "h:mm A");
  if (time.minutes() === 0) {
    return props.cellData.text;
  } else {
    return "";
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(celldisplay.value), 1))
}
}

})